import { HttpClient, HttpErrorResponse } from "@angular/common/http";
import { Injectable } from "@angular/core";
//import { Observable } from "rxjs/internal/Observable";
import { Observable, throwError } from 'rxjs';
import { catchError, map, retry } from 'rxjs/operators';

@Injectable()
export class HttpService {

  constructor(private httpClient: HttpClient) { }

  public get<T>(url: string, options: any = {}): Observable<any> {
    return this.httpClient.get(url, options).pipe(catchError(this.handleError));
  }

  public post<T>(url: string, data: any, options?: any): Observable<any> {  
    return this.httpClient.post(url, data, options)
      .pipe(map(res => res));
  }

  public async postAsync(url: string, data: any, options?: any): Promise<object> {
    var promise = await this.httpClient.post(url, data, options).toPromise();
    return promise;
  }

  public async getAsync(url: string, options: any = {}): Promise<object> {
    var promise = await this.httpClient.get<object>(url, options).toPromise();
    return promise;
  }

  public put<T>(url: string, data: any, options?: any): Observable<any> {
    return this.httpClient.put(url, data, options)
      .pipe(map(res => res));
  }

  public delete<T>(url: string, options: any = null): Observable<any> {
    return this.httpClient.delete(url, options)
      .pipe(catchError(this.handleError));
  }

  private handleError(httpError: HttpErrorResponse) {
    debugger;
    if (httpError.error instanceof ErrorEvent) {
      return Observable.throw(httpError.error.message);


    } else {
      return Observable.throw(httpError.error
        `Backend returned code ${httpError.status}, ` +
        `body was: ${httpError.error}`
      );
      //console.error(`Backend returned code ${httpError.status}, ` + `body was: ${httpError.error}`);
    }
    //return Observable.throw(httpError);
  };
}
